// extracted by mini-css-extract-plugin
export default {"emailPrefix":"CurrentEmail_emailPrefix__99ZP7"};